































































import { Component, Mixins } from "vue-property-decorator";
import { AccountingPointsModule } from "@/store/accountingpoints.module";
import { translate } from "@/utils";
import { AccountingPoint } from "~/AccountingPoint.type";
import { PointModule } from "@/store/point.module";
import TableCellTooltip from "@/components/ui/TableCellTooltip.vue";
import { ContractIdValidatorMixin } from "@/mixins/ContractIdValidatorMixin";

@Component({
  components: { TableCellTooltip },
})
export default class AccountingPointsView extends Mixins(
  ContractIdValidatorMixin,
) {
  get headers() {
    return [
      {
        text: this.$t("accountingPoints.account_point_number"),
        value: "account_point_number",
        sortable: false,
      },
      {
        text: this.$vuetify.breakpoint.xsOnly
          ? this.$t("accountingPoints.meter_next_verify_date")
          : this.$t("accountingPoints.account_point_name"),
        value: this.$vuetify.breakpoint.xsOnly
          ? "meter_next_verify_date"
          : "account_point_name",
        sortable: false,
        class: "w-150",
      },
      {
        text: this.$vuetify.breakpoint.xsOnly
          ? this.$t("accountingPoints.account_point_name")
          : this.$t("accountingPoints.meter_next_verify_date"),
        value: this.$vuetify.breakpoint.xsOnly
          ? "account_point_name"
          : "meter_next_verify_date",
        sortable: false,
        class: "w-150",
      },
      {
        text: this.$t("accountingPoints.tarif_value"),
        value: "tarif_value",
        sortable: false,
        class: "w-120",
        align: "end",
      },
      {
        text: this.$t("accountingPoints.net_node_name"),
        value: "net_node_name",
        sortable: false,
        class: "w-150",
      },
      {
        text: this.$t("accountingPoints.account_point_full_address_name"),
        value: "account_point_full_address_name",
        sortable: false,
      },
      {
        text: "",
        value: "is_connected",
        sortable: false,
      },
    ];
  }

  get columns() {
    return [
      "account_point_number",
      this.$vuetify.breakpoint.xsOnly
        ? "meter_next_verify_date"
        : "account_point_name",
      this.$vuetify.breakpoint.xsOnly
        ? "account_point_name"
        : "meter_next_verify_date",
      "tarif_value",
      "net_node_name",
      "account_point_full_address_name",
    ];
  }

  get pointTypeList() {
    return [
      {
        id: 0,
        name: this.$t("accountingPoints.all"),
      },
      {
        id: 1,
        name: this.$t("accountingPoints.connecting"),
      },
      {
        id: 2,
        name: this.$t("accountingPoints.disconnecting"),
      },
    ];
  }

  get pointListPagination() {
    return AccountingPointsModule.pointListPagination;
  }
  set pointListPagination(val) {
    AccountingPointsModule.setPointListPagination(val);
    this.loadPoints();
  }

  get pointType() {
    return AccountingPointsModule.pointType;
  }

  set pointType(val) {
    AccountingPointsModule.setPointType(val);
    this.pointListPagination.page = 1;
    this.loadPoints();
  }

  get loading() {
    return AccountingPointsModule.pointListLoading;
  }

  get getPointList() {
    const items = translate(AccountingPointsModule.pointList);
    return items;
  }

  get pointListLength() {
    return AccountingPointsModule.pointListLength;
  }

  async mounted() {
    await this.validateContractId();
    AccountingPointsModule.setNewList();
    this.loadPoints();
  }

  loadPoints() {
    AccountingPointsModule.getPointList({
      contractId: parseInt(this.$route.params.id),
      iLimit: this.pointListPagination.itemsPerPage,
      iOffset:
        this.pointListPagination.itemsPerPage *
        (this.pointListPagination.page - 1),
      tiType: this.pointType,
    });
  }

  handleClick(value: AccountingPoint) {
    PointModule.selectPointAndRoute(value.account_point_rid);
  }
}
